/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MoveReportQuery model module.
 * @module model/MoveReportQuery
 * @version 0.0.1
 */
class MoveReportQuery {
    /**
     * Constructs a new <code>MoveReportQuery</code>.
     * @alias module:model/MoveReportQuery
     */
    constructor() { 
        
        MoveReportQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MoveReportQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MoveReportQuery} obj Optional instance to populate.
     * @return {module:model/MoveReportQuery} The populated <code>MoveReportQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MoveReportQuery();

            if (data.hasOwnProperty('machineSerial')) {
                obj['machineSerial'] = ApiClient.convertToType(data['machineSerial'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MoveReportQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MoveReportQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['machineSerial'] && !(typeof data['machineSerial'] === 'string' || data['machineSerial'] instanceof String)) {
            throw new Error("Expected the field `machineSerial` to be a primitive type in the JSON string but got " + data['machineSerial']);
        }

        return true;
    }


}



/**
 * @member {String} machineSerial
 */
MoveReportQuery.prototype['machineSerial'] = undefined;






export default MoveReportQuery;

